import { Sport } from '@/feature/event-details-sbk/types';

export const normalizeSportName = (sportName: string): string => sportName.toLowerCase().replace(/ /g, '_');

export const getSportKey = (sport: Sport) => {
    return sport?.name && normalizeSportName(sport.name);
};
